import React, { Component } from 'react';
import AppBar from 'material-ui/AppBar';
import ChevronLeft from 'material-ui/svg-icons/navigation/chevron-left'
import ActionHome from 'material-ui/svg-icons/action/home';
import TextField from 'material-ui/TextField';
import selfPayComsumablestore from '../store/SelfPayComsumablestore';
import { observer } from 'mobx-react';
import {withRouter} from "react-router-dom";
import ActionSearch from 'material-ui/svg-icons/action/search';
import RaisedButton from 'material-ui/RaisedButton';




const styles = {   
    radioButton: {
      marginBottom: 16,      
    },
    card:{
        marginBottom: "5px",
    },
    cardheader:{
        fontSize: "19px",     
    },
    selectfield:{
        marginTop: "-25px"
    },
    textfield:{
        width: "50%",
        fontSize: "13px"
    },
    leftHalfTextField:{
        marginRight: "10px",
        fontSize: "13px"
    },
    rightHalfTextField:{
        marginLeft: "10px",
        fontSize: "13px"
    }
    
  };



class Query extends Component {

    constructor(props){
        super(props)        
        this.handleSubmit = this.handleSubmit.bind(this)
        this.home = this.home.bind(this)      
    }  

    home(){
        window.location.href = /m/        
    }  

    onChange(factor){
        return (event)=>
        selfPayComsumablestore.setValue(factor, event.target.value)
    }

    handleSubmit(){                
        selfPayComsumablestore.verifyValue()        
            if(selfPayComsumablestore.allowSummit === true){                  
                // selfPayComsumablestore.setLoaddata();       
                this.props.history.push("/result?"+
                "nhiIdno="+selfPayComsumablestore.querydata.nhiIdno+"&"+
                "keyword="+selfPayComsumablestore.querydata.keyword+"&"+               
                "nhiCode="+selfPayComsumablestore.querydata.nhiCode+"&"+
                "codeNo="+selfPayComsumablestore.querydata.codeNo+"&"+
                "lowPrice="+selfPayComsumablestore.querydata.lowPrice+"&"+
                "highPrice="+selfPayComsumablestore.querydata.highPrice
            );
                selfPayComsumablestore.allowSummit = false;
            }else{
                selfPayComsumablestore.allowSummit = false;                
            }     
        
    }




    render() {

        let strUrl = window.location.search;      
        
        let getPara, ParaVal;
        let aryPara = [];

        if (strUrl.indexOf("?") !== -1) {
        let getSearch = strUrl.split("?");
        getPara = getSearch[1].split("&");
        for (let i = 0; i < getPara.length; i++) {
            ParaVal = getPara[i].split("=");
            aryPara.push(ParaVal[0]);
            aryPara[ParaVal[0]] = ParaVal[1];
        }
        }

      return (
        <div className="SelfPayComsumableQuery" style={{paddingBottom: "10px"}}>
        {
              aryPara.app === 'true' ? null :
            <AppBar 
            title={<div>自費醫材查詢<span style={{ fontSize: '11px' }}>{}</span></div>}
            style={{ backgroundColor: 'white', textAlign: 'center', height: '44px' }}
            titleStyle={{ color: 'black', height: '44px', fontWeight: '500', fontSize: '17px', lineHeight: '44px', weight: '46%', textAlign: 'center' }}
            iconElementLeft={<ChevronLeft onClick={this.home}/>}
            iconStyleLeft={{"cursor": "pointer"}}             
            iconElementRight={<ActionHome onClick={this.home} />}
            iconStyleRight={{"cursor": "pointer"}}
            />
            
            }
            <div className="SelfPayComsumableQuery_content" style={{"margin": "5px 25px 5px 25px"}}>    
             
                <div className="single_inputField"  style={{"height": "48px", display: "flex", alignItems:"center", justifyContent:"center","marginBottom": "10px"}}>
                    <div
                    style={{width:"50%"}}
                    >自費特材健保碼︰</div>
                    <TextField
                        hintText="請輸入自費特材健保碼"
                        style={styles.textfield}                        
                        value={selfPayComsumablestore.querydata.nhiCode}
                        onChange={this.onChange('nhiCode')}
                    />
                </div>
                <div className="single_inputField"  style={{"height": "48px", display: "flex", alignItems:"center", justifyContent:"center","marginBottom": "10px"}}>
                    <div
                    style={{width:"50%"}}
                    >關鍵字︰</div>
                    <TextField
                    hintText="請輸入關鍵字"
                    style={styles.textfield}
                    fullWidth={true}
                    value={selfPayComsumablestore.querydata.keyword}
                    onChange={this.onChange('keyword')}
                    />
                </div>
                <div className="single_inputField"  style={{"height": "48px", display: "flex", alignItems:"center", justifyContent:"center","marginBottom": "10px"}}>
                    <div
                    style={{width:"50%"}}
                    >許可證字號︰</div>
                    <TextField
                    hintText="請輸入許可證字號"
                    style={styles.textfield}
                    fullWidth={true}
                    value={selfPayComsumablestore.querydata.nhiIdno}
                    onChange={this.onChange('nhiIdno')}
                    />
                </div>
                <div className="single_inputField"  style={{"height": "48px", display: "flex", alignItems:"center", justifyContent:"center","marginBottom": "10px"}}>
                    <div
                    style={{width:"50%"}}
                    >院內代碼︰</div>
                    <TextField
                    hintText="請輸入院內代碼"
                    style={styles.textfield}
                    fullWidth={true}
                    value={selfPayComsumablestore.querydata.codeNo}
                    onChange={this.onChange('codeNo')}
                    />
                </div>
                <div className="single_inputField"  style={{"height": "48px", display: "flex", alignItems:"center", justifyContent:"center","marginBottom": "10px"}}>
                    <div
                    style={{width:"50%"}}
                    >價格區間︰</div>
                    <div
                    style={{width: "50%", display: "flex", alignItems:"center", justifyContent:"center"}}
                    >
                    <TextField
                    hintText="最小值"                    
                    fullWidth={false}
                    style={styles.leftHalfTextField}                    
                    value={selfPayComsumablestore.querydata.lowPrice}
                    onChange={this.onChange('lowPrice')}
                    />~
                    <TextField
                    hintText="最大值"
                    hintStyle={{textAlign: "center"}}
                    style={styles.rightHalfTextField}
                    fullWidth={false}                    
                    value={selfPayComsumablestore.querydata.highPrice}
                    onChange={this.onChange('highPrice')}
                    />元
                    </div>
                   
                </div>
                


             {/* <Card style={styles.card}>
                <CardHeader title="自費特材健保碼" titleStyle={styles.cardheader}/> 
                <CardText> 
                    <TextField
                    hintText="請輸入自費特材健保碼"
                    style={styles.textfield}
                    fullWidth={true}
                    value={selfPayComsumablestore.querydata.nhiCode}
                    onChange={this.onChange('nhiCode')}
                    />
                </CardText>    
            </Card>

             <Card style={styles.card}>
                <CardHeader title="關鍵字" titleStyle={styles.cardheader}/> 
                <CardText> 
                    <TextField
                    hintText="請輸入關鍵字"
                    style={styles.textfield}
                    fullWidth={true}
                    value={selfPayComsumablestore.querydata.keyword}
                    onChange={this.onChange('keyword')}
                    />
                </CardText>    
            </Card>             

            <Card style={styles.card}>
                <CardHeader title="許可證字號" titleStyle={styles.cardheader}/> 
                <CardText> 
                    <TextField
                    hintText="請輸入許可證字號"
                    style={styles.textfield}
                    fullWidth={true}
                    value={selfPayComsumablestore.querydata.nhiIdno}
                    onChange={this.onChange('nhiIdno')}
                    />
                </CardText>    
            </Card>

            <Card style={styles.card}>
                <CardHeader title="價格區間" titleStyle={styles.cardheader}/> 
                <CardText> 
                    <TextField
                    hintText="最小值"
                    style={{marginTop: "-20px", width: "20%", textAlign:"center", marginRight: "10px"}}
                    fullWidth={false}
                    value={selfPayComsumablestore.querydata.lowPrice}
                    onChange={this.onChange('lowPrice')}
                    />~
                    <TextField
                    hintText="最大值"
                    hintStyle={{textAlign: "center"}}
                    style={{marginTop: "-20px", width: "20%", textAlign:"center", margin: "0 10px"}}
                    fullWidth={false}                    
                    value={selfPayComsumablestore.querydata.highPrice}
                    onChange={this.onChange('highPrice')}
                    />元

                </CardText>    
            </Card> */}

            <RaisedButton 
            label='查詢'
            labelStyle={{ fontSize: '18px' }}
            primary={true}
            icon={<ActionSearch />}
            overlayStyle={{ display: 'flex', alignItems: 'center', justifyContent:'center'}}
            buttonStyle={{backgroundColor:"rgb(100, 181, 246)"}}
            style={{display:'block', width:'96px', margin:"20px auto"}}
            onClick={this.handleSubmit}
             />
            </div>


        </div>
    );
  }
}

export default withRouter(observer(Query));



// WEBPACK FOOTER //
// ./src/components/layout/Query.js